import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export enum Permissions {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}

export type UserPermission = Static<typeof UserPermissionSchema>;
export const UserPermissionSchema = Type.Object(
  {
    retailUnitId: Type.String(),
    permission: Type.Enum(Permissions),
  },
  { $id: 'UserPermissionSchema' }
);
